webpackJsonp([107818501498521],{

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.postQuery = undefined;
	exports.default = Template;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(21);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Template(_ref) {
	  var data = _ref.data;
	
	  var post = data.markdownRemark;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/blog' },
	      'Go Back'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      'h1',
	      null,
	      post.frontmatter.title
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Posted by ',
	      post.frontmatter.author,
	      ' on ',
	      post.frontmatter.date
	    ),
	    _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: post.html } })
	  );
	}
	
	var postQuery = exports.postQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-post-js-0668ad1c8e9fa38db975.js